export default __webpack_public_path__ + "static/media/checkbox-checked-yono@2x.df31e83b.png";